import type { Routes } from "@angular/router";
import { Dashboard } from "./dashboard/dashboard";
import { inject } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { LayoutService } from "../../../services/layout.service";

export const dashboardRoutes: Routes = [
  {
    path: '',
    loadComponent: () => Dashboard,
    title: async () => {
      const title = await firstValueFrom(inject(LayoutService).systemTitle$);
      return `${title} - Dashboard`;
    }
  }
];
